import { useContext } from 'react';
import { HotelContext } from '../contexts/HotelContext';

// A custom hook allows us to test better.
export const useHotelContext = () => useContext(HotelContext);

export default useHotelContext;
